/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Object containing information needed for handling the input fields.
 */
export interface AnalyticFilterTypeInputField { 
    /**
     * Internal AnalyticFilterType Key
     */
    id?: number;
    /**
     * Minimum number of characters for a request to be started in the input field.
     */
    minChars?: number;
    /**
     * Flag indicating whether a request may start with an empty input field.
     */
    minOverride?: number;
}

